<div class="wrapper" [ngClass]="{'with-margin-bottom':withMarginBottom,'no-margin-bottom':noMarginBottom}" *ngIf="!isEnglishLevel">

    <div class="info">
        <div class="title">{{ exam.title }}</div>

        <div class="details">
            <div>
                <img src="assets/images/icons/calendar.svg" alt="calendar">
                 {{('schedulePage.availableUntil')|transloco }}  {{exam.endAt}}
            </div>
            <div>
                <img src="assets/images/icons/clock.svg" alt="clock">
                {{exam.time}} {{('schedulePage.minute')|transloco }}
            </div>
            <div>
                <img src="assets/images/icons/dumbbells.svg" alt="clock">
                {{exam.triesLimit}} {{('schedulePage.tries')|transloco }}
            </div>

        </div>
    </div>

    <div class="btn-wrapper">

        <button type="button" class="btn dark-btn"  *ngIf="exam.uuid!= undefined" (click)="goToTest(exam.uuid)">{{('schedulePage.doTest')|transloco }} </button>
    </div>
</div>


<div class="wrapper green-bg" [ngClass]="{'with-margin-bottom':withMarginBottom,'no-margin-bottom':noMarginBottom}" *ngIf="isEnglishLevel">

    <div class="info english-levels">
        <div class="title"> {{('schedulePage.checkEnglishLevel')|transloco }} </div>

        <div class="details">
<!--            <div>-->
<!--                <img src="assets/images/icons/calendar.svg" alt="calendar">-->
<!--                Активний до  {{exam.endAt}}-->
<!--            </div>-->
<!--            <div>-->
<!--                <img src="assets/images/icons/clock.svg" alt="clock">-->
<!--                {{exam.time}} хв-->
<!--            </div>-->
            <div *ngIf="this.tryInfo">
                <img src="assets/images/icons/dumbbells.svg" alt="clock">
               {{this.try}} {{ this.tryInfo|transloco }}
            </div>

        </div>
    </div>

    <div class="btn-wrapper">

        <button type="button" class="btn dark-btn"  (click)="getEnglishLevelExamUrl()"> {{('schedulePage.doTest')|transloco }} </button>
    </div>
</div>
